<template>
	<div class="fill-wh">
		<v-navigation-drawer v-model="showMenu" app>
			<nav-menu />
		</v-navigation-drawer>

		<slot name="toolbar">
			<v-app-bar app dark>
				<v-app-bar-nav-icon
					@click.stop="showMenu = !showMenu"
				/>
				<v-toolbar-title>K4Ops</v-toolbar-title>
			</v-app-bar>
		</slot>

		<v-content class="fill-wh">
			<slot />
		</v-content>

		<slot name="footer" />
	</div>
</template>

<script>
export default {
	data() {
		return {
			drawer: false,
		};
	},

	computed: {
		hideMenu() {
			return this.$route.meta.hideMenu;
		},

		showMenu: {
			get() {
				return this.drawer && !this.hideMenu;
			},

			set(value) {
				this.drawer = value;
			},
		},
	},
};
</script>
